import { render, staticRenderFns } from "./BacAlert.vue?vue&type=template&id=2c18be4d&scoped=true&"
import script from "./BacAlert.vue?vue&type=script&lang=ts&"
export * from "./BacAlert.vue?vue&type=script&lang=ts&"
import style0 from "./BacAlert.vue?vue&type=style&index=0&id=2c18be4d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c18be4d",
  null
  
)

export default component.exports